/**
 * Custom events and tags for Microsoft Clarity, loaded by the tag in `client/index.html`.
 *
 * Every call is a no-op when the tag is missing (blocked by the browser, or a test), and nothing
 * here may carry personal data: event names and tag values are fixed codes, never what the buyer
 * typed. Clarity filters sessions by these names, so renaming one breaks the saved filters.
 */

type ClarityFn = (command: string, ...args: string[]) => void;

function clarityFn(): ClarityFn | null {
  const candidate = (globalThis as { clarity?: unknown }).clarity;
  return typeof candidate === "function" ? (candidate as ClarityFn) : null;
}

export function clarityEvent(name: string): void {
  try {
    clarityFn()?.("event", name);
  } catch {
    /* analytics must never break the page */
  }
}

export function claritySet(key: string, value: string): void {
  try {
    clarityFn()?.("set", key, value);
  } catch {
    /* analytics must never break the page */
  }
}
